import {Col, Row} from "reactstrap";
import React from "react";

const CUSTOMER_CARE_NUMBER = process.env.REACT_APP_CUSTOMER_CARE_NUMBER;
const CUSTOMER_CARE_WHATSAPP = process.env.REACT_APP_CUSTOMER_CARE_WHATSAPP;
const CUSTOMER_CARE_EMAIL = process.env.REACT_APP_CUSTOMER_CARE_EMAIL;

export default class ContactDetails extends React.Component {


    constructor(props, context) {
        super(props, context);
        this.customerCareWhatsappPretty = this.formatNumber(CUSTOMER_CARE_WHATSAPP);
        this.customerCareNumberPretty = this.formatNumber(CUSTOMER_CARE_NUMBER);
    }

    formatNumber(number) {
        if (number.startsWith("27")) {
            return "(+27) " + number.substring(2, 4)
                + " " + number.substring(4, 7)
                + " " + number.substring(7, 11);
        }
        return number;
    }

    render() {
        return <div className="step_contact_support">
            <Row>
                <Col>
                    <a href={"https://wa.me/" + CUSTOMER_CARE_WHATSAPP}>
                        <i className="fa fa-whatsapp whatsapp-icon"/> {this.customerCareWhatsappPretty}
                    </a>
                </Col>
            </Row>
            <Row>
                <Col>
                    <a href={"tel:" + CUSTOMER_CARE_NUMBER}>
                        <i className="fa fa-phone"/> {this.customerCareNumberPretty}
                    </a>
                </Col>
            </Row>
            <Row>
                <Col>
                    <a href={"mailto:" + this.props.emailAddress ? this.props.emailAddress : CUSTOMER_CARE_EMAIL}>
                        <i className="fa fa-envelope"></i> {this.props.emailAddress ? this.props.emailAddress : CUSTOMER_CARE_EMAIL}
                    </a>
                </Col>
            </Row>
        </div>
    }
}